import jQuery from 'jquery';
let $ = jQuery;

import './Widget.js';
import 'HSNDIR/Carousel.js';

/**
* new HSN.Widget.AltImageCarousel(config)
* - config (Object): A configuration object for the [[HSN.Widget.AltImageCarousel]]
*   consisting of the following keys:
*   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
*   - container (HTMLElement | jQuery | String): A jQuery object with a ul of li's of img's
*   - preloadFirstImage (bool): UnLazy the 2nd image in the carousel
*   - useSlider (bool): Add the slider to the bottom of the container that represent slide count and position
**/
HSN.Widget.AltImageCarousel = function (config) {
    var scope = this;
    scope.application = config.application || HSN.Instance();
    scope.container = $(config.container);
    scope.carousel = $('ul', scope.container);
    scope.preloadFirstImage = config.preloadFirstImage || false;
    scope.isMobile = scope.application.DeviceInformation.IsMobile && !scope.application.DeviceInformation.IsTablet;
    scope.images = $('img', scope.carousel);

    scope.useSlider = config.useSlider || false;
    scope.sliderMarker;
    scope.sliderMarkerPercent;

    if (scope.carousel.data('hsn-carousel')) {
        return;
    }

    scope.images.show();

    new HSN.Carousel({
        carousel: scope.carousel,
        fade: true,
    });

    if (scope.preloadFirstImage) {
        scope.LoadLazyImg(1);
    }

    if (scope.useSlider) {
        scope.slider = $('<div class="slider" />');
        scope.sliderMarker = $('<div class="marker" />');
        scope.container.append(scope.slider.append(scope.sliderMarker));
        scope.sliderMarkerPercent = 100 / scope.images.length;
        scope.sliderMarker.css('width', scope.sliderMarkerPercent + '%');
    }

    scope.container.on('click', '.next', scope.OnNext.bind(scope));
    scope.container.on('click', '.prev', scope.OnPrev.bind(scope));
    scope.carousel.on('beforeChange', scope.OnBeforeSlideChanged.bind(scope));
};

HSN.Widget.AltImageCarousel.prototype = {
    OnNext: function(e) {
        var scope = this;
        e.stopPropagation();
        var newIndex = scope.carousel.slick('slickCurrentSlide');
        scope.LoadLazyImg(newIndex);
        scope.LoadLazyImg(newIndex + 1);
    },
    OnPrev: function(e) {
        e.stopPropagation();
    },
    OnBeforeSlideChanged: function(e, slick, currentSlide, nextSlide) {
        var scope = this;
        scope.LoadLazyImg(nextSlide);
        if (scope.useSlider) {
            scope.UpdateSlider(nextSlide);
        }
    },
    LoadLazyImg: function(index) {
        var scope = this;
        var cur = scope.images.eq(index).filter('.lazy-hover');
        cur.attr('src', cur.data('original'))
            .removeClass('lazy-hover');
    },
    UpdateSlider: function(index) {
        var scope = this;
        scope.sliderMarker.css('left', (scope.sliderMarkerPercent * index) + '%');
    },
    Destroy: function() {
        var scope = this;
        scope.carousel.slick('slickGoTo', 0, true);
        scope.carousel.slick('unslick');
        if (scope.useSlider) {
            scope.slider.remove();
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/AltImageCarousel.js